import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss']
})
export class SectionHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() classes = 'background-light cream-light-bg';
  @Input() buttonText: string;
  @Input() buttonUrl: string;
  @Input() buttonParams: any;
  @Input() buttonClass = 'btn-secondary1';
  @Input() mobileContentNextLine = false;
  @Input() mobileHideTitle = false;
  @Input() minTitleWidth = '0px';
  @Input() showGasLogo = false;

  constructor() { }

  ngOnInit() {
  }

  goto(event, href) {
    event.preventDefault();
    event.stopPropagation();
  //console.log('goto', href);
    window.open(href, '_blank');
  }
}
